import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

/**
 * System-standard confirmation dialog. Use this everywhere instead of window.confirm.
 *
 * variant="danger"   — red confirm button (default; use for delete/destructive actions)
 * variant="primary"  — orange confirm button (use for non-destructive confirmations)
 */
const ConfirmModal = ({
    isOpen,
    title = 'Confirm',
    description,
    typedConfirmLabel,
    typedConfirmValue,
    onTypedConfirmChange,
    onCancel,
    onConfirm,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    loading = false,
    error,
    variant = 'danger'
}) => {
    if (!isOpen) return null;

    const confirmBtnClass = variant === 'primary'
        ? 'px-4 py-2 bg-[#FF5733] hover:bg-[#ff4520] text-white rounded-sm text-sm font-medium disabled:opacity-50 transition-colors'
        : 'px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-sm text-sm font-medium disabled:opacity-50 transition-colors';

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-sm shadow-xl w-full max-w-md mx-4 p-6">
                <div className="flex justify-between items-start mb-4">
                    <h3 className="text-base font-bold text-gray-900">{title}</h3>
                    <button
                        onClick={onCancel}
                        className="text-gray-400 hover:text-gray-600 p-1 -mt-1 -mr-1"
                    >
                        <FontAwesomeIcon icon={faTimes} className="text-sm" />
                    </button>
                </div>

                {description && (
                    <p className="text-sm text-gray-600 mb-4">{description}</p>
                )}

                {typedConfirmLabel && (
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            {typedConfirmLabel}
                        </label>
                        <input
                            value={typedConfirmValue}
                            onChange={(e) => onTypedConfirmChange && onTypedConfirmChange(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-sm text-sm focus:outline-none focus:ring-1 focus:ring-gray-400"
                        />
                    </div>
                )}

                {error && (
                    <div className="text-sm text-red-500 mb-3">{error}</div>
                )}

                <div className="flex justify-end gap-2 mt-2">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-sm text-sm font-medium hover:bg-gray-50 transition-colors"
                    >
                        {cancelText}
                    </button>
                    <button
                        disabled={loading}
                        onClick={onConfirm}
                        className={confirmBtnClass}
                    >
                        {loading ? 'Processing...' : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
